import { TitleCasePipe, DatePipe } from '@angular/common';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { Status, Answer, ObjectNames, Severity } from '../../constants/constants';
import { DiscountService } from '../discount/discount.service';
import { AdditionalfeesService } from '../additionlfees/additionalfees.service';
import { SetupService } from '../setup.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { discountSectionOptions  } from '../discount/discount.module.enum';

@Component({
  selector: 'app-additionlfees',
  templateUrl: './additionlfees.component.html',
  styleUrls: ['./additionlfees.component.scss']
})
export class AdditionlfeesComponent implements OnInit, OnChanges {

  @Input() groups: any[] = [];
  @Input() baseCurrency: any;
  @Input() discountBy: any[] = [];
  @Input() financialAccounts: any[] = [];
  additionalFeeForm: FormGroup;
  allDiscounts: any[] = [];
  addEditDiscountHeader: string;
  displayAdditionalFeesAdd: boolean = false;
  isSystem: boolean = false;
  isAddDiscount: boolean = false;
  isDuplicacy: boolean = false;
  allLimitations: any[] = [];
  enable: boolean = false;
  answertypeConstants = Answer;
  discountConstantsProperty = ObjectNames.setupConstants;
  statusConstants = Status;
  typeId: number;
  minimumDate = new Date();
  expenseAccountList: any[] = [];
  incomeAccountList: any[] = [];
  discountSectionOptions : any = discountSectionOptions ;
  // fraction digits
  fractionDigits: number = 0;

  constructor(private fb: FormBuilder, private discountService: DiscountService, private additionalfeesService: AdditionalfeesService, private confirmationService: ConfirmationService,
    private messageService: MessageService, private titlecasePipe: TitleCasePipe, private datePipe: DatePipe,
    private app: AppMainComponent, private setupService: SetupService, private importService: ImportserialService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.discountBy?.currentValue) {
      this.discountBy = changes?.discountBy?.currentValue;
    }
  }

  ngOnInit(): void {
    this.setupService.getAdditionalFees().subscribe(addfees => {
      if (addfees) {
        this.showAddAdditionalFees();
      }
    })
    this.additionalFeeForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      discountBy: [''],
      discountValue: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      isCoupanCode: [false],
      coupanCode: [''],
      isCumulative: [false],
      limitationId: [0],
      discountCategoryId: [null, [Validators.required]],
      limitationValue: [''],
      incomeAccount: [0, [Validators.required]],
      expenseAccount: [0],
      isTaxable: [true],
      statusId: [true],
      isValid: [true],
      validFromDate: [''],
      validToDate: ['']
    });
    this.getDiscountGroup();
    this.getAdditionalfeesList();
    this.getFractionDigits();
  }

  getFractionDigits() {
    this.importService
      .getDecimalValue()
      .subscribe({
        next: (value) => {
          if (value) {
            this.fractionDigits = value;
          }
        },
        error: (error) => { },
      });
  }

  getDiscountGroup() {
    const additionalfeesGroup = this.groups.filter(group => group.name == ObjectNames.setupConstants.Additionalfees_Name)[0];
    this.getAllDiscountTypes(additionalfeesGroup?.id);
  }

  getAllDiscountTypes(groupId) {
    this.additionalfeesService.getAllDiscountTypes(groupId).subscribe(resp => {
      this.typeId = resp[0].id;
      this.getAdditionalfeesList()
    })
  }

  // getAdditionalfeesList(typeId){
  //   this.typeId = typeId;
  //   this.additionalfeesService.getAdditionalfeesList(typeId).subscribe(resp=>{
  //     this.allDiscounts = resp;
  //    })
  // }


  getAdditionalfeesList(status?) {
    this.discountService.getSetAdditionalFeesConfig(status).subscribe((fees) => {
      this.enable = fees.item1;
      this.allDiscounts = fees.item2;
    })
  }

  getIncomeAccount() {
    const incomeAccount = this.financialAccounts?.filter(acc => acc.labelName == ObjectNames.setupConstants.incomeAccount)[0];
    return (incomeAccount.children?.filter(child => child.labelName == ObjectNames.setupConstants.incomeAccount)[0]);
  }

  showAddAdditionalFees() {
    this.addEditDiscountHeader = ObjectNames.setupConstants.AddAdditionalFeesTitle;
    this.isAddDiscount = true;
    this.isSystem = false;
    this.displayAdditionalFeesAdd = true;
    this.additionalFeeForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      discountBy: [this.discountBy[0]],
      discountValue: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      isCoupanCode: [false],
      coupanCode: [''],
      isCumulative: [false],
      limitationId: [0],
      discountCategoryId: [null, [Validators.required]],
      limitationValue: [''],
      incomeAccount: [this.getIncomeAccount(), [Validators.required]],
      expenseAccount: [0],
      isTaxable: [false],
      statusId: [true],
      isValid: [true],
      validFromDate: [new Date()],
      validToDate: [null]
    });
  }

  showEditAdditionalFees(additionalFee) {
    this.addEditDiscountHeader = ObjectNames.setupConstants.EditAdditionalFeesTitle;
    this.displayAdditionalFeesAdd = true;
    this.isAddDiscount = false;
    this.isSystem = false;
    additionalFee.validFromDate = new Date(this.datePipe.transform(additionalFee.validFromDate, 'MM/dd/yyyy'));
    if (additionalFee.validToDate) {
      additionalFee.validToDate = new Date(this.datePipe.transform(additionalFee.validToDate, 'MM/dd/yyyy'));
    }
    if (additionalFee.createdSource == 'System') {
      this.isSystem = true;
    }
    this.additionalFeeForm.patchValue(additionalFee);
    this.additionalFeeForm.controls['statusId'].setValue(additionalFee.statusId == Status.ACTIVE ? true : false);
    const filteredDiscountType = this.discountBy.filter(type => type.id == additionalFee.discountBy)[0];
    this.additionalFeeForm.controls['discountBy'].setValue(filteredDiscountType);
    const filteredLimitationType = this.allLimitations.filter(limit => limit.id == additionalFee.limitationId)[0];
    this.additionalFeeForm.controls['limitationId'].setValue(filteredLimitationType);

    //For Parent Financial Account
    const filteredFinancialId = this.financialAccounts?.filter(finance => finance.value?.id == additionalFee.incomeAccount)[0];
    this.additionalFeeForm.controls['incomeAccount'].setValue(filteredFinancialId);
    //For Child Financial Account
    this.financialAccounts.forEach(finance => {
      const childAccount = finance.children?.filter(
        (child) => child.value?.id == additionalFee.incomeAccount
      )[0];
      if (childAccount) {
        this.additionalFeeForm.controls['incomeAccount'].setValue(childAccount);
      }
    });
    //For Sub-Child Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(element => {
        const subChildAccount = element.children?.filter(
          (child) => child.value?.id == additionalFee.incomeAccount
        )[0];
        if (subChildAccount) {
          this.additionalFeeForm.controls['incomeAccount'].setValue(subChildAccount);
        }
      });
    });
     //For forth level Financial Account
     this.financialAccounts.forEach(finance => {
      finance.children?.forEach(fnc => {
        fnc.children?.forEach(element => {
          const forthLevelChildAccount = element.children?.filter(
            (child) => child.value?.id == additionalFee.incomeAccount
          )[0];
          if (forthLevelChildAccount) {
            this.additionalFeeForm.controls['incomeAccount'].setValue(forthLevelChildAccount);
          }
        });
      });
    });
  }


  validateAdditionalFeesName(value): boolean {
    if (!value?.name?.trim()) {
      return false;
    }
    this.isDuplicacy = this.allDiscounts?.some((ele) => ele.name?.toLowerCase() === value.name.toLowerCase() && ele.id !== value.id);
    return this.isDuplicacy;
  }

  saveAdditionalFee(value) {
    value.statusId = (value.statusId ? Status.ACTIVE : Status.INACTIVE);
    value.discountBy = value.discountBy.id;
    value.incomeAccount = (value.incomeAccount ? value.incomeAccount?.value?.id : 0);
    value.discountEnabled = true;
    value.typeId = this.typeId;
    if (value.limitationId && value.limitationId.name == ObjectNames.setupConstants.Limit[0]) {
      value.limitationValue = '';
    }
    value.limitationId = (value.limitationId && value.limitationId.id);
    value.description = value.name;
    value.isTaxable = this.additionalFeeForm.get('discountCategoryId').value !== 2 && value.isTaxable;
    if (!value.isCoupanCode) {
      value.coupanCode = '';
    }
    const isDuplicacy = this.validateAdditionalFeesName(value)
    if (this.isAddDiscount && !isDuplicacy) {
      this.discountService.addDiscount(value).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Additional Fees Added successfully...' });
        this.getAdditionalfeesList()
        this.displayAdditionalFeesAdd = false;
      }).catch(() => {
        this.displayAdditionalFeesAdd = false;
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    } else if (!isDuplicacy) {
      value.updatedBy = this.app.userId;
      value.updatedDate = new Date().toISOString();
      value.updatedSource = this.app.userIP;
      this.discountService.updateDiscount(value).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Additional Fees Updated successfully...' });
        this.getAdditionalfeesList()
        this.displayAdditionalFeesAdd = false;
      }).catch(() => {
        this.displayAdditionalFeesAdd = false;
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    }
  }
  onCancel() {
    this.displayAdditionalFeesAdd = false;
    this.isDuplicacy = false;
  }
  checkDeleteStatus(additionalFee) {
    this.setupService.checkDeleteStatus(additionalFee.id, 'addfees').subscribe(check => {
      if (!check.item1) {
        this.deleteAdditionalFee(additionalFee);
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  deleteAdditionalFee(additionalFee) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Additional Fees?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.discountService.deleteDiscount(additionalFee.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allDiscounts.indexOf(additionalFee);
          this.allDiscounts.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

}
